import { createMfaAuthStore } from "@ayla/auth";
import { apiClient } from "@/lib/apiClient";

export const useAuthStore = createMfaAuthStore({
  loginEndpoint: "/auth/token",
  checkAuthEndpoint: "/user/me/full",
  axios: apiClient,
  devtools: import.meta.env.DEV,
});
